import {React} from 'common'
import Dialog from './Dialog'
import FormSection from 'components/Control/Form/FormSection'
import {useForm} from 'react-hook-form'
import {useEffect, useMemo} from 'react'
import {onSubmit} from 'services/utils/toastUtils'
import {useTranslation} from 'react-i18next'
import {zodResolver} from '@hookform/resolvers/zod'

const DialogForm = ({
    fields,
    i18nCategory,
    useGetByIdQuery = () => ({}),
    useFormLogic = () => ({}),
    useCreateMutation,
    useEditMutation,
    setOpenDialog,
    itemName,
    itemId,
    isLoading,
    validationSchema,
    ...p
}) => {
    const {t} = useTranslation()
    const {data: defaultValue, isLoading: isLoadingItem} = useGetByIdQuery(itemId, {skip: !itemId})
    const methods = useForm({
        resolver: validationSchema && zodResolver(validationSchema),
        defaultValues: defaultValue,
    })
    const {
        handleSubmit,
        reset,
        formState: {errors},
        watch,
    } = methods
    console.log('errors', errors)
    console.log('watch', watch())
    useEffect(() => {
        reset(defaultValue)
    }, [defaultValue, reset])

    const [doCreate] = useCreateMutation()
    const [doEdit] = useEditMutation()

    const submitCreate = handleSubmit((itemData) => {
        onSubmit({
            itemData,
            itemName,
            doSomething: doCreate,
            setOpenDialog,
            reset,
            commandType: 'create',
            t,
        })
    })
    const submitEdit = handleSubmit((itemData) =>
        onSubmit({
            itemData: {...itemData, _id: itemId},
            itemName,
            doSomething: doEdit,
            setOpenDialog,
            reset,
            commandType: 'edit',
            t,
        })
    )

    const submitDialogForm = useMemo(
        () => (itemId ? submitEdit : submitCreate),
        [itemId, submitEdit, submitCreate]
    )

    const {fields: controlledFields} = useFormLogic({fields, methods})

    return (
        <Dialog
            isLoading={isLoading || isLoadingItem}
            onSubmit={submitDialogForm}
            itemName={itemName}
            handleSubmit={handleSubmit}
            {...p}>
            <FormSection
                fields={controlledFields || fields}
                methods={methods}
                i18nCategory={i18nCategory}
            />
        </Dialog>
    )
}

export default DialogForm
